import { useMutation } from "@tanstack/react-query";

import { createMeeting } from "../api/createMeeting";

export const useCreateMeeting = () => {
  return useMutation({
    mutationFn: createMeeting,
  });
};
